export function  persianPrice(price, dedcimalParts=3){
  if(price === '0E-10'){
    return '۰'
  }
  if (price){

      const roundedPrice = parseFloat(price).toFixed(3)

      let persianNumber = "";
      let persianDecimalNumber = "";
      let stringN = price.toString();
      let stringArray = stringN.split(".")
      let digitPart = stringArray[0];
      let decimalPart = stringArray[1];
      // console.log('digitPart price is: ', digitPart)
      // console.log('decimalPart price is: ', decimalPart)

      let finalDecimalNumber = '';
      const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
      const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
      for ( var i = 0; i < digitPart.length; i++ ) {
        for ( var j = 0; j < englishDigits.length; j++ ) {
          if ( stringN.substr( i, 1 ) === englishDigits[ j ] ) {
            persianNumber = persianNumber + farsiDigits[ j ];
          }
        }
      }
      if(decimalPart){
        for ( var i = 0; i < decimalPart.length; i++ ) {
          for ( var j = 0; j < englishDigits.length; j++ ) {
            if ( decimalPart.substr( i, 1 ) === englishDigits[ j ] ) {
              persianDecimalNumber = persianDecimalNumber + farsiDigits[j];
            }
          }
        }
      }

      let digitNumber = addNecessaryVirgool(persianNumber);
      finalDecimalNumber = persianDecimalNumber.slice(0, dedcimalParts);
      if(finalDecimalNumber){
        return digitNumber + '/' + finalDecimalNumber;
      }
      return digitNumber;
  
    }
    else
      return '---'
}


export function  persianPriceNoLimit(price){
  if(price === '0E-10'){
    return '۰'
  }
  if (price){

      const roundedPrice = parseFloat(price)

      let persianNumber = "";
      let persianDecimalNumber = "";
      let stringN = price.toString();
      let stringArray = stringN.split(".")
      let digitPart = stringArray[0];
      let decimalPart = stringArray[1];

      let finalDecimalNumber = '';
      const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
      const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
      for ( var i = 0; i < digitPart.length; i++ ) {
        for ( var j = 0; j < englishDigits.length; j++ ) {
          if ( stringN.substr( i, 1 ) === englishDigits[ j ] ) {
            persianNumber = persianNumber + farsiDigits[ j ];
          }
        }
      }
      if(decimalPart){
        for ( var i = 0; i < decimalPart.length; i++ ) {
          for ( var j = 0; j < englishDigits.length; j++ ) {
            if ( decimalPart.substr( i, 1 ) === englishDigits[ j ] ) {
              persianDecimalNumber = persianDecimalNumber + farsiDigits[j];
            }
          }
        }
      }

      let digitNumber = addNecessaryVirgool(persianNumber);
      finalDecimalNumber = persianDecimalNumber;
      if(finalDecimalNumber){
        return digitNumber + '/' + finalDecimalNumber;
      }
      return digitNumber;
  
    }
    else
      return '---'
}

  export function  persianDigitPrice(price){
  
    if (price){
        const sign = numberSign(price)
        // console.log('sign is: ', sign)
        let persianNumber = "";
        let persianDecimalNumber = "";
        let stringN = price.toString();
        let stringArray = stringN.split(".")
        let digitPart = stringArray[0];
        let decimalPart = stringArray[1];
        let finalDecimalNumber = '';
        const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
        const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
        for ( var i = 0; i < digitPart.length; i++ ) {
          for ( var j = 0; j < englishDigits.length; j++ ) {
            if ( stringN.substr( i, 1 ) === englishDigits[ j ] ) {
              persianNumber = persianNumber + farsiDigits[ j ];
            }
          }
        }
        if(decimalPart){
          for ( var i = 0; i < decimalPart.length; i++ ) {
            for ( var j = 0; j < englishDigits.length; j++ ) {
              if ( decimalPart.substr( i, 1 ) === englishDigits[ j ] ) {
                persianDecimalNumber = persianDecimalNumber + farsiDigits[j];
              }
            }
          }
        }
  
        let digitNumber = addNecessaryVirgool(persianNumber);
        finalDecimalNumber = persianDecimalNumber.slice(0, 2);
        if(finalDecimalNumber){
          return `${digitNumber}${sign}`;
        }
        return `${digitNumber}${sign}`;
    
      }
      else
        return '---'
    }


  export function persianNumber(number){
    if (number){
      let persianNumber = "";
      let stringNumber = number.toString();
      const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
      const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
      for ( var i = 0; i < stringNumber.length; i++ ) {
        for ( var j = 0; j < englishDigits.length; j++ ) {
          if ( stringNumber.substr( i, 1 ) === englishDigits[ j ] ) {
            persianNumber = persianNumber + farsiDigits[ j ];
          }
        }
      }
      return persianNumber;
    }
    else
      return ''
  }
  

  export function persianNumberToEnglishNumber(number){
    if (number){
      let englishNumber = "";
      let stringNumber = number.toString();
      const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
      const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
      for ( var i = 0; i < stringNumber.length; i++ ) {
        for ( var j = 0; j < englishDigits.length; j++ ) {
          if ( stringNumber.substr( i, 1 ) === farsiDigits[j] ) {
            englishNumber = englishNumber + englishDigits[j];
          }
        }
      }
      return englishNumber;
    }
    else
      return ''
  }

  
  export function convertPersianDateWithEnglishDigitToPersianDigitDate(theDate){
    let stringArray = theDate.split("/");
    let year = stringArray[0]
    let month = stringArray[1]
    let day = stringArray[2]

    let persianYear = persianNumber(year)
    let persianMonth = persianNumber(month)
    let persianDay = persianNumber(day);

    return `${persianYear}/${persianMonth}/${persianDay}`;

  }

  export function numberSign(value){
    if(value < 0){
      return '-'
    } else {
      return ''
    }
  }

  function addNecessaryVirgool(persianNumber){
    let m = "";
    if(persianNumber){
      for (let i = 0; i < persianNumber.length; i++ ) {
        var c = persianNumber.substr( persianNumber.length - i - 1, 1 );
        if (i % 3 === 0 && i > 0 ) {
          m = c + ',' + m;
        } else {
          m = c + m;
        }
      }
    }
    return m;

  }


  function toPersianPrice(price){
    if (price){
      let persianNumber = "";
      let stringN = price.toString();
      const farsiDigits = [ '۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹' ];
      const englishDigits = [ '0', '1', '2', '3', '4', '5', '6', '7', '8', '9' ];
      for ( var i = 0; i < stringN.length; i++ ) {
        for ( var j = 0; j < englishDigits.length; j++ ) {
          if ( stringN.substr( i, 1 ) === englishDigits[ j ] ) {
            persianNumber = persianNumber + farsiDigits[ j ];
          }
        }
      }
      let m = "";
      for (let i = 0; i < persianNumber.length; i++ ) {
        var c = persianNumber.substr( persianNumber.length - i - 1, 1 );
        if (i % 3 === 0 && i > 0 ) {
          m = c + ',' + m;
        } else {
          m = c + m;
        }
      }
      return m;
  
    }
    else
      return '---'
  }



/**
 * Converts:
 *
 * Persian:
 * ۰۱۲۳۴۵۶۷۸۹
 *
 * Arabic:
 * ٠١٢٣٤٥٦٧٨٩
 *
 * Arabic decimal separator:
 * ٫
 *
 * to:
 *
 * 0123456789.
 */
export const normalizeNumberInput = (value) => {
    if (value === null || value === undefined) {
        return '';
    }

    return String(value)
        // Persian digits
        .replace(/[۰-۹]/g, (char) =>
            String(char.charCodeAt(0) - '۰'.charCodeAt(0))
        )

        // Arabic digits
        .replace(/[٠-٩]/g, (char) =>
            String(char.charCodeAt(0) - '٠'.charCodeAt(0))
        )

        // Arabic decimal separator
        .replace(/٫/g, '.');
};